export const liveComments = [
  {
    id: "cm-01",
    name: "深夜翻档案",
    text: "把两版声明并排放，第 3 段那句'视情况调整'的态度差得挺明显。",
    time: "6 分钟前",
    likes: 86,
  },
  {
    id: "cm-02",
    name: "只看时间线",
    text: "还是那个 17 分钟最要命，其他都是情绪推理，等平台日志出来再说。",
    time: "21 分钟前",
    likes: 142,
  },
  {
    id: "cm-03",
    name: "路过的路人甲",
    text: "难得看到不站队的复盘，把两边说法都列出来才看得清到底在吵什么。",
    time: "48 分钟前",
    likes: 203,
  },
  {
    id: "cm-04",
    name: "考据爱好者",
    text: "第 04 条口径变化才是关键，很多人根本没注意到统计范围改了。",
    time: "1 小时前",
    likes: 118,
  },
];